export const getUrlParams = (key: string): string | null => {
	const href = location.href;
	const index = href.indexOf("?");
	let val: string | null = null;

	if (index !== -1) {
		const str = href.substring(index + 1);
		const arr = str.split("&");

		for (let i = 0; i < arr.length; i++) {
			const arrItem = arr[i].split("=");
			// setCookie(arrItem[0], arrItem[1])

			if (arrItem[0] === key) {
				val = arrItem[1];
				break;
			}
		}
	}

	return val;
};
const TokenKey = `${getUrlParams("cert")}`;

export function getToken(key?: string) {
	return localStorage.getItem(key ? key : TokenKey) || "";
}
export function setToken(token: string, key?: string) {
	localStorage.setItem(key ? key : TokenKey, token);
}
export function removeToken() {
	localStorage.removeItem(TokenKey);
	localStorage.removeItem("token");
}
export function getError(): any[] {
	const list = sessionStorage.getItem("ErrorKey");
	return list ? JSON.parse(list) : [];
}
export function setError(errors: any[]): void {
	sessionStorage.setItem("ErrorKey", JSON.stringify(errors));
}
export function removeError(): void {
	sessionStorage.removeItem("ErrorKey");
}
